import http from "../requestBase";
import "../types/typdefs";

import View from "./View";
const API_BASE = "api/SurveyInstances";
const API_HIST = "api/SurveyInstanceHistory";

/**
 *
 * @param {Object} filterStrings Contains the Columms as key and the filter as values
 * @param {Number} pageSize Items per page
 * @param {Number} selectedPage The Selected Field
 * @param {String} sortField The Field to sort by
 * @param {('asc'|'desc')} [sortOrder]  Sort order
 * @returns {Promise<SurveyInstanceData[]>}
 */
function getAll(
  filterStrings,
  pageSize = 20,
  selectedPage = 1,
  sortField = "SurveyInstanceId",
  sortOrder = "asc"
) {
  let queryString = `${API_BASE}/Get?page_size=${pageSize}&page=${selectedPage}&sort_column=${sortField}&sort_order=${sortOrder}`;
  queryString = encodeURI(queryString);

  //TODO: validate Filter and trim
  let Filter = _.isEmpty(filterStrings) ? "" : filterStrings;

  return http.post(queryString, { Filter });
}

/**
 *
 * @param {SurveyInstanceData} content
 * @returns
 */
function create(content) {
  return http.post(`${API_BASE}`, content);
}

/**
 *
 * @param {number} id The SurveyInstanceId
 * @returns
 */
function deleteByID(id) {
  return http.delete(`${API_BASE}/${id}`);
}
/**
 * Fetch the History of the check
 * The fields wich  are in the history are defined in the DB
 * @param {number} id - The check id
 * @returns the Object with the checkHistory
 */
function getHistoryByID(id) {
  return http.get(`${API_HIST}/${id}`);
}

/**
 * Fetch the History of the check
 * The fields wich are in the history are defined in the DB
 * @param {string} guid - The check guid
 * @returns the Object with the checkHistory
 */
function getHistoryByGUID(guid) {
  return http.get(`${API_HIST}/${guid}`);
}

/**
 * change the status of a single SurveyInstance
 * @param {number} id - the Id
 * @param {number} newstatus - the new Status
 * @returns
 */
function changeStatus(id, newstatus) {
  let sendData = {
    SurveyInstanceIds: [id],
    SurveyInstanceStatusId: newstatus,
  };
  return http.put(API_BASE, sendData);
}

/**
 * change the status of multiple SurveyInstances
 * @param {number[]} id - the id's of the SurveyInstances
 * @param {number} newstatus - the new status of all the SurveyInstances
 * @returns
 */
function changeStatusMultiple(id, newstatus) {
  let sendData = {
    SurveyInstanceIds: id,
    SurveyInstanceStatusId: newstatus,
  };
  return http.put(API_BASE, sendData);
}

/**
 * 
 * @param {number} id 
 * @returns 
 */
function getOneSurveyAndSurveyInstanceJson(id) {
  return http.post(`${API_BASE}/SurveyAndSurveyInstanceJsons/`, JSON.stringify([id]));
}

/**
 * @param {Object} filterStrings Contains the Columms as key and the filter as values
 * @param {*} filter 
 * @returns {Promise<SurveyInstanceData[]>}
 */
function getExport(clientGuid, fileType, filterStrings){
  let Filter = _.isEmpty(filterStrings) ? "" : filterStrings;

  return http.post(`${API_BASE}/Export/${clientGuid}?file_type=${fileType}`, { Filter });
}

/**
 * All API calls concerning Checks/SurveyInstances
 */
let UseSurveyInstance = {
  getAll,
  create,
  deleteByID,
  getHistoryByGUID,
  getHistoryByID,
  changeStatus,
  changeStatusMultiple,
  getOneSurveyAndSurveyInstanceJson,
  getExport,
  View,
};

export default UseSurveyInstance;



// WEBPACK FOOTER //
// ./src/services/SurveyInstances/index.js